<template>
<div class="p-3 position-relative">
    <div class="title-graph"><h5> Power </h5></div>
    <DxChart :size="{height: 300 }" :data-source="ems_data" ref='graphV2'>
        <DxCommonSeriesSettings type="stepline" argument-field="time" />
        <DxSeries value-field="power_profile" name="Power Profile        "  :point="{visible: false}"/>
        <DxArgumentAxis 
          :visual-range="[new Date().setHours(0,0,0,0), 
                          new Date().setHours(23, 59, 59, 999)+24*60*60*1000+1]"
          :tick-interval="1000*60*60"
          :label="{customizeText:customizeHours}">
          <DxConstantLine :value="new Date()" :label="{text:''}"/>
        </DxArgumentAxis>
          
        <DxValueAxis
          :endOnTick="true"
          placeholder-size="7"
          :tick="{ visible: false }"
          :label="{aligment:'left',customizeText:( value ) => { return `${value.valueText}W`}}" />
        <DxTooltip location="center" :customize-tooltip="customizeTooltip_power" :enabled="true" /> 
    </DxChart>
</div>
<div class="p-3 position-relative">
    <div class="title-graph"><h5>Load </h5></div>
    <DxChart :size="{height: 300}" :data-source="ems_data" ref='graphV2'>
        <DxCommonSeriesSettings type="stepline" argument-field="time" />
        <DxSeries value-field="load_consumed" name="Load Consumed   "  :point="{visible: false}"/>
        <DxSeries value-field="load_estimation" name="Load Estimation"  :point="{visible: false}"/>
        <DxArgumentAxis
          :visual-range="[new Date().setHours(0,0,0,0), 
                          new Date().setHours(23, 59, 59, 999)+24*60*60*1000+1]"
          :tick-interval="1000*60*60"
          :label="{customizeText:customizeHours}">
          <DxConstantLine :value="new Date()" :label="{text:''}" />
        </DxArgumentAxis>
        <DxValueAxis
          :endOnTick="true"
          :visual-range="[0,null]"
          placeholder-size="7"
          :tick="{ visible: false }"
          :label="{alignment:'left', customizeText:( value ) => { return `${value.valueText}W`}}" />
        <DxTooltip location="center" :customize-tooltip="customizeTooltip_load" :enabled="true" />
    </DxChart>
</div>
<div class=" p-3 position-relative">
    <div class="title-graph"><h5> PV </h5></div>
    <DxChart :size="{height: 300}" :data-source="ems_data" ref='graphV2'>
        <DxCommonSeriesSettings type="stepline" argument-field="time" />
        <DxSeries value-field="total_active_power" name="Total active power"  :point="{visible: false}"/>
        <DxSeries value-field="pv_estimation" name="PV Estimation"  :point="{visible: false}"/>
        <DxArgumentAxis
          :visual-range="[new Date().setHours(0,0,0,0), 
                          new Date().setHours(23, 59, 59, 999)+24*60*60*1000+1]"
          :tick-interval="1000*60*60"
          :label="{customizeText:customizeHours}">
          <DxConstantLine :value="new Date()" :label="{text:''}" />
        </DxArgumentAxis>
        <DxValueAxis
          :endOnTick="true"
          placeholder-size="7"
          :tick="{ visible: false }"
          :label="{customizeText:( value ) => { return `${value.valueText}W`}}" />
        <DxTooltip location="center" :customize-tooltip="customizeTooltip_pv" :enabled="true" />
    </DxChart>
</div>
<div class="p-3 position-relative">
    <div class="title-graph"><h5> Electricity Price </h5></div>
    <DxChart :size="{height: 300}" :data-source="ems_data" ref='graphV2'>
        <DxCommonSeriesSettings argument-field="time" type="stackedbar" :point="{visible:false}" />
        <DxSeries value-field="fixed_price" name="Fixed Price           "/>
        <DxSeries value-field="pool_price" name="Pool Price"/>
        <DxSeries value-field="total" name="Total Price" type="stepline" />
        <!--<DxSeries value-field="power_price" name="Power Price [€/MW]" type="stepline"  axis="power"/>-->      
        <DxArgumentAxis
          :visual-range="[new Date().setHours(0,0,0,0), 
                          new Date().setHours(23, 59, 59, 999)+24*60*60*1000+1]"
          :tick-interval="1000*60*60"
          :label="{customizeText:customizeHours}">
          <DxConstantLine :value="new Date()" :label="{text:''}" />
        </DxArgumentAxis>
        <DxValueAxis
          placeholder-size="7"
          :tick="{ visible: false }"
          :label="{customizeText:( value ) => {return `${value.value}€/MWh`}}" 
          :visual-range="{endValue:250}"/>
        <DxTooltip location="center" :customize-tooltip="customizeTooltip_price" :enabled="true" />
    </DxChart>
</div>
</template>

<script>
import { ref,onBeforeUnmount, reactive } from 'vue';
import RawDataService from '../services/RawDataServiceTemplate';
import {  DxChart, DxCommonSeriesSettings, DxSeries, DxArgumentAxis, DxValueAxis, DxTooltip,DxConstantLine } from 'devextreme-vue/chart';


export default {
  components: { 
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxTooltip,
    DxConstantLine
  },
  data(){
  
  },
  setup() {

    const algorithmsDataService = new RawDataService(`algorithms/eod`);
    const frontendConfigDataService = new RawDataService(`frontend/ems-view`);
    const influxDataService = new RawDataService(`influx`); 
    
   /* const BESS_POWER_SIGNAL = "MEAS_SYS_POWER_ACTIVE_ALL"
    const GRID_POWER_SIGNAL = "Three phase Active Power"
    const PV_POWER_SIGNAL = "Output power";*/

    const data= reactive({
      pvSignal:{
        asset:"PV Logger",
        signal: "Output power"
      },
      loadSignals:[
        { asset: "PCS 1", signal: "MEAS_SYS_POWER_ACTIVE_ALL" },
        { asset: "PCS 2", signal: "MEAS_SYS_POWER_ACTIVE_ALL" },
        { asset: "PV Logger", signal: "Output power" },
        { asset: "Analyzer", signal: "Three phase Active Power" }
      ]
    })
    const ems_data = new ref([])
    const refresh = async () =>{
      const now = new Date();
      const initTime= new Date().setHours(0,0,0,0);
      const endTime= now.getTime();

      algorithmsDataService.getAll().then(res=>{
        ems_data.value=ems_data.value.filter(el=> !Object.keys(el).includes('power_profile') &&
        !Object.keys(el).includes('pool_price') &&
        !Object.keys(el).includes('pv_estimation') && 
        !Object.keys(el).includes('load_estimation') )
        if(res.data.currentPowerProfile.datetime_unix_ms){
          for(let i=0;i<res.data.currentPowerProfile.datetime_unix_ms.length;i++){
            ems_data.value.push({
                time: res.data.currentPowerProfile.datetime_unix_ms[i]  ,
                power_profile: res.data.currentPowerProfile.value[i] ,
            })
          }
          for(let i=0;i<res.data.pool_price.datetime_unix_ms.length;i++){
            ems_data.value.push({
                time: res.data.pool_price.datetime_unix_ms[i],
                pool_price: res.data.pool_price.value[i],
                fixed_price: res.data.fixed_price.value[i],
                total: res.data.total.value[i] 
            })
          }

          for(let i=0;i<res.data.pvEstimation.datetime_unix_ms.length;i++){
            ems_data.value.push({
                time: res.data.pvEstimation.datetime_unix_ms[i]  ,
                pv_estimation: res.data.pvEstimation.value[i]  ,
            })
          }

          for(let i=0;i<res.data.loadEstimation.datetime_unix_ms.length;i++){
            ems_data.value.push({
                time: res.data.loadEstimation.datetime_unix_ms[i] ,
                load_estimation: res.data.loadEstimation.value[i] ,
            })
          }
        }
      })

      let signals=[]
      for (let sig of data.loadSignals){
        const data = await influxDataService.getByKey(sig.asset+'/signalStorage/'+sig.signal+'?timeInterval=15m&dateStart='+initTime+'&dateEnd='+endTime )
        let aux=[]
        for(let dat of data){
          aux.push({time:dat.time,value:dat[sig.signal]})
        }
        signals.push(aux)
      }

      const total_active_power = await influxDataService.getByKey(data.pvSignal.asset+'/signalStorage/'+data.pvSignal.signal+'?timeInterval=15m&dateStart='+initTime+'&dateEnd='+endTime )
      ems_data.value = ems_data.value.filter(el=> !Object.keys(el).includes('total_active_power') && !Object.keys(el).includes('load_consumed')  )

      const results = [];
      signals.forEach(subarray => {
          subarray.forEach(objeto => {
              const { time, value  } = objeto;
              const element=results.find(el=>new Date(el.time).getTime()==new Date(time).getTime())
              if (element) {
                  element.load_consumed += value;
              } else {
                results.push({
                  time: new Date(time).getTime(),
                  total_active_power: total_active_power.find(el=>el.time==time)?.[data.pvSignal.signal],
                  load_consumed: value
                })
              }
          });
      });
      ems_data.value.push(...results)
    }

    function startInterval(time) {
      let refresh_timer;
      if( time > 0) 
        refresh_timer = setInterval(() => {
            refresh()
        }, time ); // 1000 milisegundos = 1 segundo
      
      return refresh_timer
    }

    function stopInterval(refresh_timer) {
      clearInterval(refresh_timer);
    }

    // Init

    const loadData= async ()=>{
      frontendConfigDataService.getAll().then((res)=>{
        ems_data.value=[]
        data.pvSignal = res.data.pvSignal;
        data.loadSignals = res.data.loadSignals;
        refresh()
      })
    }
    loadData()
    let refresh_timer = startInterval(10000)
    
    // unmount
    onBeforeUnmount(() => { stopInterval(refresh_timer) })

    //Auxiliar functions
    const customizeHours = ( value ) => {
      var date = new Date(value.value)
      return formatDate(date);
    };
    function formatDate(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes ;
      return strTime;
    }
    
    function customizeTooltip_power(value){
        return { text: `${(value.value/1000000).toFixed(3)} MW` }
    }
    function customizeTooltip_load(value){
      const time = value.argument
      const load_est = ems_data.value.find(el=> el.time==time && !!el.load_estimation)?.load_estimation 
      const load_consum = ems_data.value.find(el=> el.time==time && !!el.load_consumed)?.load_consumed 
        return { text: `Load estimated: ${(load_est/1000000).toFixed(3)} MW \n
          Load consumed: ${(load_consum/1000000).toFixed(3)} MW` }
    }
    function customizeTooltip_pv(value){
      const time = value.argument
      const pv_est = ems_data.value.find(el=> el.time==time && !!el.pv_estimation)?.pv_estimation 
      const pv_consum = ems_data.value.find(el=> el.time==time && !!el.total_active_power)?.total_active_power 
        return { text: `PV estimated: ${(pv_est/1000000).toFixed(3)} MW \n
          Total active power: ${(pv_consum/1000000).toFixed(3)} MW` }
    }
    function customizeTooltip_price(value){
      const time = value.argument
      const pool_price = ems_data.value.find(el=> el.time==time && !!el.pool_price)?.pool_price 
      const fixed_price = ems_data.value.find(el=> el.time==time && !!el.fixed_price)?.fixed_price 
      const total = ems_data.value.find(el=> el.time==time && !!el.total)?.total
        return { text: `Pool price: ${pool_price.toFixed(3)} €/MWh \n
          Fixed price: ${fixed_price.toFixed(3)} €/MWh \n
          Total price: ${total.toFixed(3)} €/MWh \n` }
    }


    return {
        ems_data,
        customizeHours,
        customizeTooltip_power,
        customizeTooltip_load,
        customizeTooltip_price,
        customizeTooltip_pv
    }
  },

}

</script>